var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',{directives:[{name:"rw",rawName:"v-rw"}],attrs:{"ghost":"","type":"error","custom-icon":"fas fa-sync-alt","text":"schedule"},on:{"on-click":function($event){return _vm.$emit('on-click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }